<template>
  <div class="authorize-container">
    <div class="authorize-form">
      <h2>Authorizing...</h2>
      <p v-if="error" class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { authService } from '../services/auth'

const router = useRouter()
const route = useRoute()
const error = ref('')

onMounted(async () => {
  try {
    const code = route.query.code as string
    if (!code) {
      throw new Error('No authorization code received')
    }

    await authService.handleCallback(code)
    router.push('/daily')
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'An error occurred during authorization'
  }
})
</script>

<style scoped>
.authorize-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.authorize-form {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.error {
  color: #dc3545;
  margin-top: 1rem;
}
</style>
